import Loading from '@/components/loading/Loading.vue'
let ConfirmConstructor, instance

const showLoading = {
  install(Vue) {
    ConfirmConstructor = Vue.extend(Loading)
    instance = new ConfirmConstructor().$mount()
    document.body.appendChild(instance.$el)

    Vue.prototype.$showLoading = options => {
      Object.assign(instance, options)
      instance.init()
    }

    Vue.prototype.$closeLoading = options => {
        Object.assign(instance, options)
        instance.close()
    }
  }
}

export default showLoading


// WEBPACK FOOTER //
// ./src/assets/js/loading.js